<section class="ml-page-guide mt-4 mb-4">
  <details [open]="defaultOpen">
    <summary class="guide-summary">
      <span class="guide-icon" aria-hidden="true">i</span>
      <span class="guide-heading">
        <strong>How to use this page</strong>
        <span>{{ purpose }}</span>
      </span>
      <span class="guide-toggle text-muted small">Open guide</span>
    </summary>

    <div class="guide-content">
      <div class="row g-3">
        <div class="col-lg-8">
          <div class="guide-label">Recommended workflow</div>
          <ol class="guide-steps mb-0">
            <li *ngFor="let step of steps">{{ step }}</li>
          </ol>
        </div>

        <div class="col-lg-4" *ngIf="important || accessNote">
          <div class="guide-note h-100">
            <div class="guide-label">Keep in mind</div>
            <p class="mb-2" *ngIf="important">{{ important }}</p>
            <p class="mb-0 text-muted" *ngIf="accessNote"><strong>Access:</strong> {{ accessNote }}</p>
          </div>
        </div>
      </div>
    </div>
  </details>
</section>
